import * as React from 'react';
import PhoneNumberInput, {
  getCountryCallingCode,
  parsePhoneNumber,
  type Country,
  type Value,
} from 'react-phone-number-input/min';

import 'react-phone-number-input/style.css';

export type PhoneData = {
  countryCode: string;
  phoneNumber: string;
  country: Country | undefined;
  fullNumber: string;
};

type PhoneInputProps = {
  value?: Value;
  onChange?: (data: PhoneData) => void;
  disabled?: boolean;
  className?: string;
};

const DEFAULT_MAX_LENGTH = 16;

const PhoneInput = ({ className = '', disabled, onChange, value }: PhoneInputProps) => {
  const [country, setCountry] = React.useState<Country | undefined>('IN');

  const handleChange = (nextValue?: Value) => {
    let phoneData: PhoneData = {
      countryCode: country ? `+${getCountryCallingCode(country)}` : '',
      phoneNumber: '',
      country,
      fullNumber: nextValue || '',
    };

    if (nextValue) {
      try {
        const parsed = parsePhoneNumber(nextValue);

        if (parsed) {
          phoneData = {
            countryCode: `+${parsed.countryCallingCode}`,
            phoneNumber: parsed.nationalNumber,
            country: parsed.country,
            fullNumber: nextValue,
          };
          setCountry(parsed.country);
        }
      } catch {
        // Keep the raw value in form state so validation can show the right error.
      }
    }

    onChange?.(phoneData);
  };

  return (
    <PhoneNumberInput
      className={`one8-phone-input ${className}`}
      value={value}
      onChange={handleChange}
      onCountryChange={setCountry}
      international
      defaultCountry="IN"
      countryCallingCodeEditable={false}
      smartCaret={false}
      maxLength={DEFAULT_MAX_LENGTH}
      disabled={disabled}
    />
  );
};

export default PhoneInput;
